import { exists } from '../runtime.js';
import './ApiActivityType.js';
import './ApiAdditionalInfoType.js';
import { ApiAddressFromJSON, ApiAddressToJSON } from './ApiAddress.js';
import './ApiAirportType.js';
import './ApiAvailState.js';
import './ApiBaggageType.js';
import './ApiBaggageUnitType.js';
import './ApiBaseDataSource.js';
import './ApiBookingAction.js';
import './ApiBookingState.js';
import './ApiCabinClass.js';
import './ApiCamperFeatureType.js';
import './ApiClientType.js';
import { ApiCommunicationDetailsFromJSON, ApiCommunicationDetailsToJSON } from './ApiCommunicationDetails.js';
import './ApiComponentPriceType.js';
import './ApiComponentType.js';
import './ApiConfigurationDataType.js';
import './ApiDebitType.js';
import './ApiDirection.js';
import './ApiDistanceUnit.js';
import './ApiDocumentSubType.js';
import './ApiDocumentType.js';
import './ApiDurationType.js';
import './ApiFilterCategory.js';
import './ApiFilterType.js';
import './ApiFuelType.js';
import { ApiGenderFromJSON, ApiGenderToJSON } from './ApiGender.js';
import './ApiImageType.js';
import './ApiInventory.js';
import './ApiItemType.js';
import './ApiNoteOriginType.js';
import './ApiNoteType.js';
import './ApiPackagePriceComponentType.js';
import './ApiPaymentDataType.js';
import './ApiPaymentOption.js';
import './ApiPaymentState.js';
import './ApiPriceModifierType.js';
import './ApiPriceType.js';
import './ApiRecommendationServiceType.js';
import './ApiRelatedServiceRelationType.js';
import './ApiRole.js';
import './ApiRowCharacteristics.js';
import './ApiSeatCharacteristics.js';
import './ApiServiceSelectionType.js';
import './ApiSortDirection.js';
import './ApiSortOption.js';
import './ApiSpecialRequestGroup.js';
import './ApiStaticContentType.js';
import './ApiTaxDisplay.js';
import './ApiTransmissionType.js';
import './ApiTravelStatusEnum.js';
import { ApiTravelerTypeFromJSON, ApiTravelerTypeToJSON } from './ApiTravelerType.js';
import './ApiVoucherDeliveryType.js';
import './ApiWalletType.js';

/* tslint:disable */
function ApiContactFromJSON(json) {
    return ApiContactFromJSONTyped(json);
}
function ApiContactFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'businessPartnerNumber': !exists(json, 'businessPartnerNumber') ? undefined : json['businessPartnerNumber'],
        'id': json['id'],
        'salutation': json['salutation'],
        'title': json['title'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'middleName': json['middleName'],
        'birthDate': (json['birthDate']),
        'age': json['age'],
        'documentNumber': !exists(json, 'documentNumber') ? undefined : json['documentNumber'],
        'bonusCardNumber': json['bonusCardNumber'],
        'communicationDetails': ApiCommunicationDetailsFromJSON(json['communicationDetails']),
        'gender': ApiGenderFromJSON(json['gender']),
        'type': ApiTravelerTypeFromJSON(json['type']),
        'countryOfIssue': !exists(json, 'countryOfIssue') ? undefined : json['countryOfIssue'],
        'nationality': !exists(json, 'nationality') ? undefined : json['nationality'],
        'expirationDate': !exists(json, 'expirationDate') ? undefined : (json['expirationDate']),
        'address': !exists(json, 'address') ? undefined : ApiAddressFromJSON(json['address']),
        '_function': json['function'],
        'department': json['department'],
        'role': json['role'],
        'adress': ApiAddressFromJSON(json['adress']),
        'password': json['password'],
        'validFrom': (json['validFrom']),
        'validUntil': (json['validUntil']),
    };
}
function ApiContactToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'businessPartnerNumber': value.businessPartnerNumber,
        'id': value.id,
        'salutation': value.salutation,
        'title': value.title,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'middleName': value.middleName,
        'birthDate': (value.birthDate),
        'age': value.age,
        'documentNumber': value.documentNumber,
        'bonusCardNumber': value.bonusCardNumber,
        'communicationDetails': ApiCommunicationDetailsToJSON(value.communicationDetails),
        'gender': ApiGenderToJSON(value.gender),
        'type': ApiTravelerTypeToJSON(value.type),
        'countryOfIssue': value.countryOfIssue,
        'nationality': value.nationality,
        'expirationDate': value.expirationDate === undefined ? undefined : (value.expirationDate),
        'address': ApiAddressToJSON(value.address),
        'function': value._function,
        'department': value.department,
        'role': value.role,
        'adress': ApiAddressToJSON(value.adress),
        'password': value.password,
        'validFrom': (value.validFrom),
        'validUntil': (value.validUntil),
    };
}

export { ApiContactFromJSON, ApiContactFromJSONTyped, ApiContactToJSON };
//# sourceMappingURL=ApiContact.js.map
